{
  "uploadFile": "Lataa tiedosto",
  "working": "Työskentelee",
  "thinking": "Ajattelee",
  "newChat": "Uusi keskustelu",
  "recentChats": "Viimeaikaiset keskustelut",
  "recents": "Viimeisimmät",
  "chat": "Keskustelu",
  "files": "Tiedostot",
  "agents": "Agentit",
  "messages_one": "{{count}} viesti",
  "messages_other": "{{count}} viestiä",
  "clickToRename": "Klikkaa nimetäksesi uudelleen",
  "deleteChat": "Poista keskustelu",
  "archive": "Arkistoi",
  "unarchive": "Palauta arkistosta",
  "archived": "Arkistoidut",
  "welcomeTitle": "Tervetuloa Agion Assistentit -palveluun",
  "welcomeSubtitle": "Aloita keskustelu Agion Assistentin kanssa tai valitse tietty agentti",
  "missionWelcomeTitle": "Missiokeskustelu",
  "missionWelcomeSubtitle": "Aloita keskustelu mission tiimin kanssa. Kaikki osallistujat näkevät viestit ja voivat vastata.",
  "agentWelcomeTitle": "Agenttikeskustelu",
  "agentWelcomeSubtitle": "Aloita keskustelu tämän agentin kanssa. Agentti auttaa sinua kykyjensä ja luottamustasonsa mukaisesti.",
  "agionAssistants": "Agion Assistentit",
  "noAgentAccess": "Ei pääsyä agentteihin",
  "noAgentAccessDesc": "Sinulla ei ole tällä hetkellä pääsyä mihinkään agentteihin. Ota yhteyttä ylläpitäjään.",
  "connecting": "Yhdistetään reaaliaikaisiin päivityksiin...",
  "reconnecting": "Yhdistetään uudelleen... (yritys {{attempt}})",
  "disconnected": "Reaaliaikaiset päivitykset katkaistu",
  "connectionError": "Yhteysvirhe - yritetään uudelleen...",
  "cancelled": "Käyttäjä peruutti pyynnön",
  "processingError": "Valitettavasti tapahtui virhe pyyntösi käsittelyssä. Yritä uudelleen.",
  "typeToMention": "Kirjoita @ mainitaksesi tiedostoja tai agentteja...",
  "referencedFiles": "Viitatut tiedostot ({{count}}):",
  "attachedFiles": "Liitetyt tiedostot ({{count}}):",
  "all": "Kaikki",
  "filesCount": "Tiedostot ({{count}})",
  "agentsCount": "Agentit ({{count}})",
  "noFilesOrAgents": "Ei tiedostoja tai agentteja saatavilla",
  "uploadFilesPrompt": "Lataa tiedostoja tai odota agenttien latautumista...",
  "noFilesFound": "Tiedostoja ei löytynyt",
  "noAgentsFound": "Agentteja ei löytynyt",
  "sendHint": "Paina Enter lähettääksesi, Shift+Enter uudelle riville",
  "mentionHint": "Kirjoita @ viitaaksesi tiedostoihin tai agentteihin",
  "attachHint": "Liitä tiedostoja klikkaamalla paperiyhdistintä",
  "attachFile": "Liitä tiedosto",
  "uploadingToStorage": "Ladataan tallennustilaan...",
  "processing": "Käsitellään...",
  "navigateHint": "↑ ↓ navigoi",
  "selectHint": "↵ valitse",
  "dismissHint": "esc sulje",
  "you": "Sinä",
  "assistant": "Assistentti",
  "generatedChart": "Luotu kaavio",
  "signOut": "Kirjaudu ulos",
  "aiAgent": "Tekoälyagentti",
  "noDescription": "Ei kuvausta saatavilla",
  "howCanIHelp": "Kuinka voin auttaa sinua tänään?",
  "addContent": "Lisää sisältöä",
  "mentionFile": "Mainitse tiedosto",
  "settings": "Asetukset",
  "history": "Historia",
  "autoSelect": "Automaattinen",
  "noResults": "Tuloksia ei löytynyt",
  "rename": "Nimeä uudelleen",
  "delete": "Poista",
  "copy": "Kopioi leikepöydälle",
  "copied": "Kopioitu!",
  "regenerate": "Luo uudelleen",
  "processedIn": "Käsitelty {{time}} s",
  "maxFilesReached": "Enintään {{max}} tiedostoa sallittu",
  "chats": "Keskustelut",
  "tasks": "tehtävää",
  "tasksCount": "{{count}} tehtävää",
  "searchChats": "Hae keskusteluja...",
  "noChatsFound": "Keskusteluja ei löytynyt",
  "participants": "osallistujaa",
  "external": "ulkoinen",
  "showingAs": "Näytetään nimellä",
  "internalNote": "Sisäinen muistiinpano",
  "internal": "Muistiinpano",
  "reply": "Vastaa",
  "replyToCustomer": "Vastaa asiakkaalle",
  "missionAccessDenied": "Sinulla ei ole pääsyä tähän missioon. Sinut on ehkä poistettu osallistujista.",
  "missionAccessDeniedMessage": "Pääsy estetty. Et ole tämän mission osallistuja.",
  "voiceInput": "Puhekomento",
  "stopRecording": "Lopeta nauhoitus",
  "recording": "Nauhoitetaan...",
  "transcribing": "Litteroidaan...",
  "microphoneAccessDenied": "Mikrofonin käyttö estetty",
  "recordingFailed": "Nauhoitus epäonnistui",
  "disclaimer": "Agentit voivat tehdä virheitä. Tarkista aina tulokset.",
  "failedToGetResponse": "Vastauksen saaminen epäonnistui",
  "downloadChart": "Lataa kaavio",
  "freePlan": "Ilmaisversio",
  "unknownMission": "Tuntematon missio",
  "unnamedMission": "Nimetön missio",
  "missions": "Missiot",
  "noMissions": "Ei missioita saatavilla",
  "createMissionInAdmin": "Luo missio hallintapaneelissa",
  "newMission": "Uusi missio",
  "awaitingHumanInput": "Odottaa ihmisen syötettä",
  "open": "Avoimet",
  "attention": "Huomio",
  "running": "Käynnissä",
  "recent": "Viimeisimmät",
  "showHosts": "Näytä isännät",
  "hideHosts": "Piilota isännät",
  "timeAgo": {
    "justNow": "juuri nyt",
    "minutesAgo": "{{count}}m sitten",
    "hoursAgo": "{{count}}h sitten",
    "daysAgo": "{{count}}pv sitten"
  },
  "recentRuns": {
    "showAll": "Näytä kaikki keskustelut",
    "showMore": "Näytä lisää keskusteluja",
    "showFewer": "Näytä vähemmän",
    "loading": "Ladataan keskusteluja…",
    "loadError": "Aiempia keskusteluja ei voitu ladata"
  },
  "missionRunning": "Missio käynnissä",
  "searchMissions": "Hae missioita...",
  "noMatchingMissions": "Ei vastaavia missioita",
  "drafts": "Luonnokset",
  "hostOnline": "Palvelin verkossa",
  "hostOffline": "Palvelin poissa verkosta",
  "hostStatusChecking": "Tarkistetaan palvelimen tilaa...",
  "hostStatusUnknown": "Palvelimen tila tuntematon",
  "hosts": "Palvelimet",
  "noHosts": "Ei palvelimia saatavilla",
  "unassigned": "Ei palvelinta",
  "hostGroup": "Palvelinryhmä",
  "selectMission": "Valitse missio",
  "selectMissionDescription": "Valitse missio sivupalkista aloittaaksesi keskustelun agentin kanssa.",
  "clickNewChatToStart": "Klikkaa \"Uusi keskustelu\" aloittaaksesi",
  "landing": {
    "title": "Mitä haluaisit tehdä?",
    "subtitle": "Valitse miten haluat aloittaa",
    "missionChat": "Missiokeskustelu",
    "missionChatDescription": "Suorita missio ja vuorovaikuta sen kanssa keskustelun kautta",
    "knowledgeBase": "Tietopankki",
    "knowledgeBaseDescription": "Kysy kysymyksiä organisaatiosi tiedoista",
    "chatWithData": "Keskustele datan kanssa",
    "chatWithDataDescription": "Kysy yhdistetyistä tietolähteistä keskustelun muodossa",
    "selectAMission": "Valitse missio aloittaaksesi",
    "noActiveMissions": "Ei aktiivisia missioita saatavilla",
    "startChat": "Aloita keskustelu",
    "autostart": "Missio käynnistyy automaattisesti",
    "searchMissions": "Hae missioita...",
    "recentlyUpdatedMissions": "Äskettäin päivitetyt missiot",
    "missionListSubtitle": "Missioni",
    "orStartNew": "tai aloita uusi keskustelu",
    "greeting": "Mitä haluaisit tehdä?",
    "inputPlaceholder": "Kuvaile mitä tarvitset tai pudota tiedosto...",
    "hint": "Kirjoita viesti tai pudota tiedosto, valitse sitten missio",
    "removeFile": "Poista tiedosto",
    "loadError": "Missioitasi ei voitu ladata",
    "noMissionsGuest": "Sinulle ei ole vielä jaettu yhtään missiota. Pyydä sinut kutsunutta henkilöä lisäämään sinut missioon.",
    "noMissionsGuestWithInviter": "Sinulle ei ole vielä jaettu yhtään missiota. Kun joku jakaa sellaisen, se näkyy täällä — pyydä {{inviter}} lisäämään sinut missioon.",
    "noMissionsReader": "Missiot, joihin sinut lisätään, näkyvät tässä.",
    "guestOrgContext": "Olet organisaatiossa {{org}}.",
    "guestOrgContextWithInviter": "Olet organisaatiossa {{org}}, kutsujana {{inviter}}.",
    "guestCapabilities": "Vierailijana voit avata ja suorittaa sinulle jaettuja missioita. Et voi luoda missioita tai kutsua muita.",
    "guestHintBody": "Vierailijana voit avata ja suorittaa {{inviter}} jakamia missioita. Uudet näkyvät täällä automaattisesti.",
    "guestHintBodyNoInviter": "Vierailijana voit avata ja suorittaa sinulle jaettuja missioita. Uudet näkyvät täällä automaattisesti.",
    "guestHintDismiss": "Hylkää",
    "draft": "Luonnos"
  },
  "welcome": {
    "greeting": "Kuinka voin auttaa sinua tänään?",
    "subtitle": "Aloita keskustelu tai valitse ehdotus alta",
    "noMissionsSubtitle": "Ei aktiivisia missioita vielä. Aloita keskustelu tai luo missio.",
    "startConversation": "Aloita uusi keskustelu",
    "missionSubtitle": "Lähetä viesti aloittaaksesi tämän mission",
    "agentsInMission": "Agentit:",
    "startMission": "Aloita missio",
    "suggestions": {
      "summarize": "Tee yhteenveto viimeisimmistä mission tuloksista",
      "agents": "Mitä agentteja on saatavilla?",
      "mission": "Auta minua luomaan uusi missio",
      "governance": "Selitä hallintopäätös"
    },
    "agentSuggestions": {
      "intro": "Kerro itsestäsi",
      "help": "Missä voit auttaa minua?"
    }
  },
  "modes": {
    "mission": "Missio",
    "kb": "Tietopankki",
    "data": "Data"
  },
  "conversationHistory": {
    "title": "Keskustelut",
    "noConversations": "Ei keskusteluja vielä",
    "startNew": "Aloita uusi keskustelu yllä"
  },
  "trigger": {
    "childMissionLaunched": "Uusi missio käynnistettiin",
    "continueWith": "Jatka missiolla {{name}}?",
    "openMission": "Avaa missio",
    "missionTriggered": "Missio käynnistetty"
  },
  "customer": {
    "historyLoadFailed": "Keskustelua ei voitu ladata Edge-palvelimelta.",
    "historyLoadFailedHint": "Ajo on voinut sanoa enemmän kuin tässä näkyy. Yritä hetken kuluttua uudelleen.",
    "historyHostUnknown": "Tämän mission ajanutta Edge-palvelinta ei ole kirjattu, joten sen keskustelua ei löydy.",
    "progress": {
      "title": "Edistyminen",
      "stepsCompleted": "{{completed}} / {{total}} vaihetta",
      "allComplete": "Kaikki vaiheet suoritettu",
      "failed": "Suoritus epäonnistui"
    },
    "missionCompleted": "Missio suoritettu onnistuneesti",
    "missionStopped": "Ajo pysäytetty",
    "missionFailed": "Jotain meni pieleen. Yritä uudelleen tai ota yhteyttä tukeen.",
    "missionAnswerTimeout": "Ajo päättyi, koska vastausta ei tullut ajoissa. Aloita uusi ajo lähettämällä viesti.",
    "missionToolReportedError": "Työkalu ei voinut käyttää tätä syötettä: {{reason}}. Tarkista syöte ja yritä uudelleen.",
    "missionCriteriaNotMet": "Ajo valmistui, mutta kaikki sen onnistumiskriteerit eivät täyttyneet. Tarkista vastaus ennen kuin luotat siihen.",
    "missionNoResourceEvidence": "Ajo ei saanut tietoja yhdistetyistä järjestelmistä, joten vastaus voi olla puutteellinen. Pyydä ylläpitäjää tarkistamaan yhteys ennen kuin luotat vastaukseen.",
    "questionExpired": "Tämä kysymys on vanhentunut",
    "reconnecting": "Yhdistetään uudelleen...",
    "streamingUnavailable": "Reaaliaikaiset päivitykset eivät ole hetkellisesti saatavilla. Voit silti selata keskusteluhistoriaa.",
    "typeMessage": "Kirjoita viesti...",
    "typeToRestart": "Kirjoita viesti aloittaaksesi uuden suorituksen...",
    "newRunDivider": "Uusi ajo aloitettu. Aiemmat viestit näkyvät viitteenä.",
    "respondToQuestion": "Kirjoita vastauksesi...",
    "waitingForMission": "Odotetaan mission vastausta...",
    "stop": "Pysäytä",
    "stopMission": "Pysäytä tehtävä",
    "pause": "Keskeytä",
    "pauseMission": "Keskeytä tehtävä",
    "resume": "Jatka",
    "resumeMission": "Jatka tehtävää",
    "historyHostOfflineNamed": "Tämän keskustelun sisältävä Edge-palvelin {{name}} on offline-tilassa. Yritä uudelleen, kun se on taas käytössä.",
    "historyHostOffline": "Tämän keskustelun sisältävä Edge-palvelin on offline-tilassa. Yritä uudelleen, kun se on taas käytössä.",
    "runHostMoved": "Tämä ajo käynnistyi toisella Edge-palvelimella, koska aiemman keskustelun sisältävä palvelin ei ole käytettävissä. Aiempien viestien tiedostot eivät ole tämän ajon käytettävissä.",
    "conversationOwnedByOther": "Tämä keskustelu kuuluu toiselle henkilölle. Vain hän voi lukea sen täällä.",
    "conversationStartedAutomatically": "Tämän keskustelun käynnisti ajastus tai laukaisin, ei henkilö. Sen sisällön voi avata vain auditointisivulta."
  },
  "kb": {
    "title": "Tietopankki",
    "placeholder": "Esitä kysymys...",
    "thinking": "Haetaan tietopankista...",
    "noSources": "Lähteitä ei löytynyt",
    "sources": "Lähteet",
    "fromOrg": "Organisaatio",
    "fromMission": "Missio",
    "askFollowUp": "Esitä jatkokysymys..."
  },
  "data": {
    "title": "Keskustele datan kanssa",
    "selectResources": "Valitse tietolähteet",
    "selectSources": "Valitse kyseltävät tietolähteet",
    "noResources": "Ei tietolähteitä saatavilla",
    "noSources": "Ei tietolähteitä saatavilla",
    "sourcesSelected": "lähdettä valittu",
    "askPrompt": "Esitä kysymys tietolähteistäsi",
    "selected": "valittu",
    "startChat": "Aloita keskustelu",
    "placeholder": "Kysy datasta...",
    "querying": "Haetaan tietolähteistä..."
  },
  "governance": {
    "prefix": "Hallinto",
    "allowed": "Hallinto: Sallittu",
    "denied": "Estetty",
    "obfuscated": "Peitetty",
    "escalated": "Eskaloitu"
  },
  "trust": {
    "tooltip": {
      "tier0": "Rajoitettu — Agentti toimii maksimivalvonnassa. Kaikki toimenpiteet vaativat hyväksynnän.",
      "tier1": "Rajallinen — Agentti voi suorittaa perustehtäviä, mutta pysähtyy tärkeissä päätöksissä.",
      "tier2": "Normaali — Agentti hoitaa rutiinityöt ja pysähtyy avainpäätöksissä.",
      "tier3": "Laajennettu — Agentilla on laajennetut oikeudet ja se toimii vähäisin pysähdyksin."
    }
  },
  "executionLog": {
    "title": "Aktiviteetti",
    "openPanel": "Avaa aktiviteetti",
    "closePanel": "Sulje aktiviteetti",
    "waitingForEvents": "Odotetaan tapahtumia...",
    "noEventsYet": "Ei tapahtumia vielä",
    "contentOnHost": "Sisältö tallennettu Edge-isännälle",
    "mission": "Tehtävä",
    "rankingDegraded": "Järjestys heikentynyt",
    "noConfidentMatch": "Ei varmaa osumaa",
    "warningCount": "{{count}} varoitus",
    "warningCount_other": "{{count}} varoitusta",
    "forced": {
      "label": "Päättyi etuajassa",
      "budget": "Päättyi etuajassa: kierrokset loppuivat. Tulos voi olla puutteellinen. Rajaa vaiheen tehtävää tai jaa vaihe osiin.",
      "stuckRepeating": "Päättyi etuajassa: toisti samaa kutsua. Tulos voi olla puutteellinen. Muuta vaiheen ohjeita.",
      "repeatedFailure": "Päättyi etuajassa toistuvien työkaluvirheiden vuoksi. Tulos voi olla puutteellinen. Tarkista vaiheen käyttämä yhteys.",
      "schemaChurn": "Päättyi etuajassa: lähdedatan rakenne muuttui jatkuvasti. Tulos voi olla puutteellinen. Tarkista lähteen skeema."
    }
  },
  "missionChat": {
    "editInDesigner": "Muokkaa suunnittelijassa"
  },
  "workflow": {
    "status": "Työnkulku: {{status}}",
    "pause": "Keskeytä",
    "resume": "Jatka",
    "cancel": "Peruuta",
    "approve": "Hyväksy",
    "reject": "Hylkää",
    "progress": "{{completed}}/{{total}} vaihetta suoritettu",
    "currentStep": "Suoritetaan: {{step}}{{agent}}",
    "turn": "Kierros {{current}}/{{max}}",
    "turnProgress": "Kierros {{current}} / {{max}}",
    "duration": "Kesto: {{duration}}",
    "waitingApproval": "{{count}} vaihetta odottaa hyväksyntää",
    "noSteps": "Työnkulun vaiheita ei ole määritetty",
    "dependsOn": "Riippuvuudet",
    "viewDetails": "Näytä työnkulun tiedot",
    "event": {
      "started": "Työnkulku aloitettu",
      "startedDescription": "Suoritetaan {{steps}} vaihetta",
      "paused": "Työnkulku keskeytetty",
      "pausedDescription": "Työnkulku on keskeytetty",
      "resumed": "Työnkulku jatkuu",
      "resumedDescription": "Työnkulun suoritus jatkuu",
      "completed": "Työnkulku valmis",
      "completedDescription": "Suoritettiin {{steps}} vaihetta ajassa {{duration}}",
      "failed": "Työnkulku epäonnistui",
      "cancelled": "Työnkulku peruutettu",
      "cancelledDescription": "Työnkulun suoritus peruutettiin",
      "stepStarted": "Vaihe aloitettu: {{step}}",
      "stepStartedAgent": "Agentti {{agent}} suorittaa",
      "stepStartedDescription": "Vaiheen suoritus aloitettu",
      "stepProgress": "Vaiheen edistyminen: {{step}}",
      "stepProgressDescription": "Kierros {{current}} / {{max}}",
      "stepCompleted": "Vaihe valmis: {{step}}",
      "stepCompletedDescription": "Valmistui ajassa {{duration}}",
      "stepFailed": "Vaihe epäonnistui: {{step}}",
      "stepWaitingApproval": "Hyväksyntä vaaditaan: {{step}}",
      "unknown": "Työnkulkutapahtuma"
    },
    "command": {
      "statusHelp": "Näytä työnkulun tila",
      "pauseHelp": "Keskeytä käynnissä oleva työnkulku",
      "resumeHelp": "Jatka keskeytettyä työnkulkua",
      "cancelHelp": "Peruuta käynnissä oleva työnkulku",
      "approveHelp": "Hyväksy odottava vaihe",
      "rejectHelp": "Hylkää odottava vaihe"
    }
  },
  "outputFile": {
    "download": "Lataa",
    "downloading": "Ladataan…",
    "downloadFailed": "Lataus epäonnistui. Yritä uudelleen.",
    "noHost": "Tämän assistentin tiedostoja ei voi vielä ladata täällä.",
    "noLongerAvailable": "Tiedosto ei ole enää saatavilla. Pyydä assistenttia luomaan se uudelleen.",
    "noAccess": "Sinulla ei ole pääsyä tähän tiedostoon.",
    "hostOffline": "Palvelin, jolle tiedosto on tallennettu, on poissa verkosta. Yritä uudelleen, kun palvelin on taas verkossa."
  },
  "delivery": {
    "waiting": "Odotetaan, että tiedostot on ladattu…",
    "sending": "Lähetetään…",
    "queued": "Jonossa: assistentti lukee viestin, kun sen nykyinen vaihe on valmis.",
    "delivered": "Toimitettu",
    "notConnected": "Ei lähetetty: yhteys assistenttiin on poikki.",
    "noReceipt": "Ei vahvistettu: kuittausta ei tullut, joten assistentti ei ehkä saanut viestiä.",
    "notStarted": "Ei lähetetty: keskustelua ei voitu aloittaa.",
    "notAccepted": "Palvelin ei vahvistanut viestiä. Yritä uudelleen. Jos ongelma toistuu, palvelin voi olla poissa verkosta tai tarvita päivityksen.",
    "undelivered": "Ei toimitettu: ajo päättyi ennen kuin assistentti luki viestin.",
    "unconfirmed": "Toimitusta ei vahvistettu: isäntä ei voinut vahvistaa saaneensa tätä vastausta.",
    "refused": "Ei toimitettu.",
    "backInComposer": "Viesti on palautettu viestikenttään, josta voit lähettää sen uudelleen.",
    "chooseAgain": "Valitse vastauksesi uudelleen."
  },
  "receiptReason": {
    "invalidMessage": "Viestiä ei voitu lukea.",
    "notSubscribed": "Tämä keskustelu ei enää seuraa ajoa. Lataa sivu uudelleen ja yritä uudelleen.",
    "senderNotAllowed": "Vain ajon käynnistänyt henkilö voi lähettää sille viestejä.",
    "runNotLive": "Ajo ei ole enää käynnissä.",
    "hostNotConnected": "Assistenttia ajava isäntä ei ole yhteydessä.",
    "runnerNotConnected": "Assistenttia ajava isäntä on yhteydessä, mutta sen suorittaja ei ole.",
    "messageTooLarge": "Viesti on liian suuri lähetettäväksi.",
    "channelFull": "Yhteys assistenttiin on ruuhkautunut. Yritä hetken kuluttua uudelleen.",
    "inboxFull": "Assistentilla on jo useita odottavia viestejä. Lähetä tämä, kun se on lukenut ne.",
    "modeDoesNotAccept": "Tämä ajo ei ota vastaan viestejä työskennellessään.",
    "duplicate": "Assistentilla on jo tämä viesti.",
    "unknownMessageType": "Palvelin ei tunnistanut viestiä; se saattaa tarvita päivityksen.",
    "runEndedBeforeDelivery": "Ajo päättyi ennen kuin assistentti luki viestin.",
    "attachmentInvalid": "Liitetiedostoja ei voitu varmistaa. Poista ne ja liitä ne uudelleen.",
    "attachmentHostMismatch": "Nämä tiedostot ladattiin toiselle palvelimelle. Liitä ne tämän suorituksen palvelimelle.",
    "attachmentHostAmbiguous": "Tiedostojen palvelinta ei voitu varmistaa. Liitä tiedostot uudelleen.",
    "attachmentTooMany": "Viestissä on liian monta tiedostoa. Poista osa tiedostoista ja yritä uudelleen.",
    "attachmentUnavailable": "Liitetiedostot eivät ole käytettävissä. Yritä uudelleen tai poista liitteet ja liitä tiedostot uudelleen."
  },
  "questionAnswerReason": {
    "answerInProgress": "Toista vastausta tähän kysymykseen tarkistetaan vielä. Odota hetki ja yritä uudelleen.",
    "answerAdmissionUnavailable": "Isäntä ei ehtinyt ottaa vastausta vastaan. Yritä uudelleen.",
    "invalidAnswer": "Vastausta ei voitu lukea. Tarkista se ja yritä uudelleen.",
    "attemptConflict": "Vastaus poikkeaa aiemmasta lähetyksestä, jonka se toistaa. Lähetä se uudelleen.",
    "questionClosed": "Tähän kysymykseen ei voi enää vastata.",
    "confirmationUnavailable": "Isäntä ei voi enää vahvistaa, saiko se tämän vastauksen.",
    "senderNotAllowed": "Sinulla ei ole oikeutta vastata tähän kysymykseen.",
    "runNotLive": "Ajo ei ole enää käynnissä.",
    "attachmentInvalid": "Liitetiedostoja ei voitu varmistaa. Poista ne ja liitä ne uudelleen.",
    "attachmentHostMismatch": "Nämä tiedostot ladattiin toiselle palvelimelle. Liitä ne tämän suorituksen palvelimelle.",
    "attachmentHostAmbiguous": "Tiedostojen palvelinta ei voitu varmistaa. Liitä tiedostot uudelleen.",
    "attachmentTooMany": "Vastauksessa on liian monta tiedostoa. Poista osa tiedostoista ja yritä uudelleen.",
    "attachmentUnavailable": "Liitetiedostot eivät ole käytettävissä. Yritä uudelleen tai poista liitteet ja liitä tiedostot uudelleen."
  },
  "questionClosed": {
    "cancelled": "Tämä kysymys peruttiin.",
    "expired": "Tämän kysymyksen vastausaika päättyi.",
    "publicationFailed": "Tätä kysymystä ei voitu näyttää, joten se suljettiin.",
    "executionEnded": "Tämä kysymys sulkeutui, kun ajo päättyi."
  },
  "composer": {
    "agentWorking": "Assistentti työskentelee. Voit vastata, kun se kysyy sinulta jotain.",
    "chooseAnOption": "Vastaa valitsemalla yksi yllä olevista vaihtoehdoista.",
    "questionClosed": "Tähän kysymykseen ei voi enää vastata.",
    "attachUnavailable": "Tämä avustaja ei voi vastaanottaa tiedostoja.",
    "attachFindingHost": "Etsitään palvelinta, joka vastaanottaa tiedostosi…",
    "attachGroupOffline": "Mikään palvelin, jolla tämä avustaja toimii, ei ole nyt verkossa, joten se ei voi vastaanottaa tiedostoja. Yritä uudelleen, kun jokin niistä palaa.",
    "attachHostNotFound": "Palvelinta, joka vastaanottaisi tiedostosi, ei löytynyt. Lataa sivu uudelleen ja yritä uudelleen.",
    "fileNotUploaded": "Tiedoston lataus epäonnistui. Yritä uudelleen tai poista tiedosto ja lähetä sitten.",
    "launchFailed": "Keskustelua ei voitu aloittaa.",
    "tooLong": "Viesti on liian pitkä lähetettäväksi. Lyhennä sitä.",
    "pasteTooLong": "Liitetty sisältö tekisi viestistä liian pitkän lähetettäväksi, joten sitä ei lisätty.",
    "notReadyTool": "Tätä avustajaa ei voi vielä käynnistää, koska sen käyttämä työkalu ei ole valmis. Pyydä sen omistajaa viimeistelemään se.",
    "notReadySetup": "Tätä avustajaa ei voi vielä käynnistää, koska sen asetukset ovat kesken. Pyydä sen omistajaa viimeistelemään ne."
  },
  "launchRefusal": {
    "defaultModelMissing": {
      "admin": "Organisaatiollasi ei ole oletuskeskustelumallia, joten tällä toimeksiannolla ei ole agenttia, jonka nimissä se voisi toimia. Valitse malli hallintakonsolissa kohdassa Hallinto > Resurssit > Mallit.",
      "member": "Organisaatiollasi ei ole oletuskeskustelumallia, joten tällä toimeksiannolla ei ole agenttia, jonka nimissä se voisi toimia. Pyydä ylläpitäjää valitsemaan malli."
    },
    "openModelSettings": "Avaa malliasetukset",
    "grantAccessNotReady": {
      "named": "Ajo ei käynnistynyt, koska tämän toimeksiannon agentin käyttöoikeudet seuraaviin resursseihin eivät ole vielä käytössä: {{resources}}. Yritä hetken kuluttua uudelleen. Jos ongelma toistuu, ota yhteyttä osoitteeseen support@agion.ai.",
      "unnamed": "Ajo ei käynnistynyt, koska tämän toimeksiannon agentin käyttöoikeudet eivät ole vielä käytössä.Yritä hetken kuluttua uudelleen. Jos ongelma toistuu, ota yhteyttä osoitteeseen support@agion.ai."
    },
    "grantAdminDenied": {
      "named": "Ajo ei käynnistynyt, koska ylläpitäjä on poistanut tämän agentin käyttöoikeuden seuraaviin resursseihin: {{resources}}. Pyydä apua ylläpitäjältäsi tai ota yhteyttä osoitteeseen support@agion.ai.",
      "unnamed": "Ajo ei käynnistynyt, koska ylläpitäjä on poistanut tämän agentin käyttöoikeuden johonkin toimeksiannon käyttämään resurssiin. Pyydä apua ylläpitäjältäsi tai ota yhteyttä osoitteeseen support@agion.ai."
    },
    "grantTrustTierTooLow": {
      "named": "Ajo ei käynnistynyt, koska tämän agentin luottamustaso ei salli sitä, mitä toimeksianto tarvitsee seuraavissa resursseissa: {{resources}}. Pyydä apua ylläpitäjältäsi tai ota yhteyttä osoitteeseen support@agion.ai.",
      "unnamed": "Ajo ei käynnistynyt, koska tämän agentin luottamustaso ei salli sitä, mitä toimeksianto tarvitsee jossakin käyttämässään resurssissa. Pyydä apua ylläpitäjältäsi tai ota yhteyttä osoitteeseen support@agion.ai."
    }
  },
  "escalations": {
    "title": "Eskalaatiot",
    "fallbackTitle": "Eskalaatio",
    "approve": "Hyväksy",
    "deny": "Hylkää",
    "reasonPlaceholder": "Perustelu (valinnainen)",
    "confirmApprove": "Vahvista hyväksyntä",
    "confirmDeny": "Vahvista hylkäys",
    "cancel": "Peruuta",
    "resolving": "Lähetetään…",
    "expired": "Vanhentunut",
    "expiredNote": "Ei enää käsiteltävissä — vaihe aikakatkaistiin ennen päätöstä.",
    "missionLabel": "Missio",
    "actionLabel": "Haluaa suorittaa",
    "ruleLabel": "Sääntö",
    "traceToggle": "Käytännön tiedot",
    "consequence": "Hyväksy suorittaa vaiheen heti · Hylkää estää sen",
    "type": {
      "actionApproval": "Hyväksyntä vaaditaan",
      "chatHandoff": "Siirtopyyntö",
      "contentReview": "Sisällön tarkistus",
      "guidance": "Ohjauspyyntö",
      "complianceReview": "Vaatimustenmukaisuuden tarkistus",
      "question": "Kysymys"
    },
    "question": {
      "answerPlaceholder": "Vastauksesi",
      "submit": "Lähetä vastaus",
      "answerLabel": "Vastaus",
      "answeredByLabel": "Vastaaja",
      "answeredAtLabel": "Vastattu",
      "answerKeptWithRun": "Vastaus säilyy ajon luona.",
      "unavailable": "Kysymystä ei voi näyttää.",
      "error": {
        "invalid": "Kysymys ei hyväksy tätä vastausta.",
        "expired": "Kysymys vanheni ennen kuin vastaus ehti perille.",
        "alreadyAnswered": "Joku muu vastasi kysymykseen ensin.",
        "forbidden": "Et voi vastata tähän kysymykseen.",
        "failed": "Vastausta ei lähetetty. Yritä uudelleen.",
        "ticketMismatch": "Vastaus ei vastannut istuntoasi. Lataa sivu uudelleen ja yritä uudelleen.",
        "ticketExpired": "Vastauksen lähettäminen kesti liian kauan. Yritä uudelleen.",
        "runNotLive": "Ajo on päättynyt, joten se ei voi ottaa vastausta vastaan.",
        "hostNotConnected": "Tätä missiota ajava isäntä ei ole yhteydessä. Yritä myöhemmin uudelleen.",
        "malformed": "Vastausta ei voitu lukea. Yritä uudelleen.",
        "unreachable": "Ajoon ei saatu yhteyttä. Yritä uudelleen.",
        "unconfirmed": "Ajo sai vastauksen, mutta sitä ei ole vielä kirjattu. Tarkista hetken kuluttua uudelleen."
      },
      "form": {
        "required": "Pakollinen",
        "submitNone": "En pystynyt selvittämään mitään näistä",
        "answeredFields": "Vastatut kentät",
        "noneAnswered": "Yhtäkään kenttää ei voitu selvittää.",
        "error": {
          "number": "Anna luku.",
          "date": "Anna koko päivämäärä."
        }
      }
    },
    "evidence": {
      "open": "Avaa aineisto",
      "hide": "Piilota aineisto",
      "opening": "Avataan…",
      "label": "Aineisto",
      "task": "Tehtävä",
      "context": "Konteksti",
      "constraints": "Rajoitteet",
      "error": {
        "unavailable": "Aineistoa ei voi avata.",
        "tooLarge": "Aineisto on liian suuri avattavaksi tässä.",
        "failed": "Aineisto ei avautunut. Yritä uudelleen."
      }
    },
    "questionCard": {
      "waiting": "Kysymys odottaa henkilöä, joka voi päättää siitä.",
      "answered": "Vastattu",
      "askedBy": "Kysyjä",
      "evidenceTitle": "Mitä asiantuntija näki",
      "evidenceUnavailable": "Aineistoa ei voi näyttää tässä.",
      "evidenceEmpty": "Asiantuntijalle ei annettu tietoja."
    },
    "header": {
      "questionWaiting": "Kysymys odottaa",
      "unknownMission": "Missio",
      "answerInEscalations": "Vastaa Eskalaatioissa"
    },
    "reviewReason": {
      "decisionCouldNotChoose": "Päätösmalli ei osannut valita.",
      "decisionUnavailable": "Päätösmalli ei ollut käytettävissä.",
      "agentUnsure": "Asiantuntijan malli ei ollut varma.",
      "agentUnavailable": "Asiantuntijan malli ei ollut käytettävissä.",
      "agentModelSkipped": "Missio kysyy suoraan ihmiseltä, kun päätösmalli ei osaa valita."
    }
  },
  "operatorTakeover": {
    "personMarker": "Henkilö",
    "takeOver": "Ota keskustelu",
    "takingOver": "Otetaan keskustelua…",
    "heldByYou": "Hoidat tätä keskustelua.",
    "openConversation": "Avaa keskustelu",
    "banner": "Vastaat asiakkaalle omalla nimelläsi",
    "holdUntil": "Hoidat tätä keskustelua kello {{time}} asti.",
    "ended": "Et enää hoida tätä keskustelua.",
    "notHeld": "Et hoida tätä keskustelua.",
    "earlierRunsIncomplete": "Osaa aiemmasta keskustelusta ei voitu ladata.",
    "placeholder": "Kirjoita asiakkaalle",
    "send": "Lähetä",
    "handBack": "Palauta agentille",
    "handingBack": "Palautetaan…",
    "handBackFailed": "Keskustelua ei palautettu. Yritä uudelleen.",
    "reply": {
      "sending": "Lähetetään…",
      "accepted": "Toimitettu asiakkaalle",
      "notSent": "Ei lähetetty: yhteys on poikki.",
      "refused": "Hylätty"
    },
    "refusal": {
      "expired": "Pyyntö vanheni ennen kuin otit keskustelun.",
      "self": "Aloitit tämän keskustelun itse, joten jonkun muun on otettava se.",
      "notPending": "Joku muu otti keskustelun, tai se päättyi.",
      "forbidden": "Et voi ottaa tätä keskustelua.",
      "failed": "Keskustelua ei otettu. Yritä uudelleen."
    },
    "replyRefusal": {
      "malformed": "Vastausta ei voitu lukea. Tarkista teksti ja lähetä uudelleen.",
      "senderNotAllowed": "Kirjaudu uudelleen vastataksesi.",
      "notSubscribed": "Keskustelu ei ole auki tässä. Lataa se uudelleen ja vastaa uudelleen.",
      "disabled": "Keskustelujen ottaminen on poistettu käytöstä.",
      "noHold": "Et enää hoida tätä keskustelua.",
      "notOperator": "Toinen henkilö hoitaa tätä keskustelua.",
      "unavailable": "Keskusteluun ei saatu yhteyttä. Yritä uudelleen.",
      "other": "Vastaus hylättiin."
    }
  },
  "notifications": {
    "hitlTitle": "Tehtävä odottaa vastaustasi",
    "governanceTitle": "Hallintailmoitus",
    "escalationTitle": "Eskalaatio odottaa päätöstä"
  },
  "delegation": {
    "blocked": {
      "label": "Asetusten estämä",
      "message": "{{agent}} ei saanut tehtävää valmiiksi: {{reason}}.",
      "targetNotBound": "järjestelmää ei ole yhdistetty tähän missioon",
      "targetNotAuthorized": "tällä missiolla ei ole oikeutta käyttää järjestelmää",
      "operationOutsideScope": "toimintoa ei sallita tässä missiossa",
      "credentialUnavailable": "yhteydellä ei ole käyttökelpoisia tunnistetietoja",
      "other": "mission asetukset eivät salli tätä pyyntöä",
      "hint": "Mission laatija tai ylläpitäjä voi muuttaa asetuksia."
    }
  },
  "launchInputs": {
    "title": "Aloitusarvot",
    "hint": "Ajo alkaa näillä arvoilla.",
    "enterValue": "Anna arvo, jotta ajo voi alkaa.",
    "invalidJson": "Anna kelvollinen JSON-arvo, esimerkiksi {\"key\": \"value\"} tai [1, 2].",
    "invalidNumber": "Anna luku.",
    "invalidInteger": "Anna kokonaisluku.",
    "invalidBoolean": "Anna true tai false.",
    "selectFile": "Valitse ladattu tiedosto",
    "uploadFile": "Lataa tiedosto",
    "uploadingFile": "Tiedostoa ladataan…",
    "uploadFailed": "Tiedoston lataus epäonnistui.",
    "retryUpload": "Yritä latausta uudelleen",
    "removeFile": "Poista tiedosto",
    "completeFile": "Valitse tiedosto, jonka lataus on valmis.",
    "nextMessageStartsRun": "Seuraava viestisi aloittaa uuden ajon.",
    "changeValues": "Muuta aloitusarvoja",
    "hideValues": "Piilota aloitusarvot"
  },
  "nextSections": {
    "attention": {
      "title": "Odottaa vastaustasi",
      "awaitingInput": "Odottaa syötettäsi",
      "policyDecision": "Käytäntöpäätös",
      "escalate": "Eskaloi"
    },
    "recent": {
      "loadError": "Viimeisimpiä keskusteluja ei voitu ladata",
      "nameNotLoaded": "Mission nimeä ei ladattu",
      "outcome": {
        "running": "Käynnissä",
        "completed": "Valmis",
        "failed": "Epäonnistui",
        "cancelled": "Pysäytetty"
      }
    }
  },
  "nextConversation": {
    "agent": "Agentti",
    "copy": "Kopioi",
    "helpful": "Hyödyllinen",
    "notHelpful": "Ei hyödyllinen",
    "attach": "Liitä tiedostoja",
    "voice": "Puhesyöte",
    "send": "Lähetä viesti",
    "hint": "Enter lähettää · Shift+Enter uusi rivi",
    "working": "Tehtävä on käynnissä",
    "governance": {
      "deny": "Estetty",
      "obfuscate": "Peitetty",
      "escalate": "Siirretty tarkistettavaksi",
      "audit": "Kirjattu"
    },
    "historyLoadError": "Tätä keskustelua ei voitu ladata Edge-palvelimelta",
    "question": {
      "closed": "Tämä kysymys ei ole enää avoinna.",
      "submit": "Lähetä vastaus",
      "atLeast_one": "Valitse vähintään {{count}} vaihtoehto.",
      "atLeast_other": "Valitse vähintään {{count}} vaihtoehtoa.",
      "otherLabel": "Muu",
      "otherPlaceholder": "Kirjoita vastauksesi"
    },
    "escalation": {
      "approve": "Hyväksy",
      "deny": "Hylkää",
      "approveConsequence": "Kun hyväksyt, {{agent}} jatkaa ajoaan ja suorittaa pyytämänsä toiminnon.",
      "denyConsequence": "Kun hylkäät, {{agent}} ei suorita toimintoa, ja ajon pyytänyt vaihe epäonnistuu.",
      "reasonLabel": "Syy",
      "reasonPlaceholder": "Syy...",
      "reasonRequired": "Syy vaaditaan.",
      "confirmApprove": "Vahvista hyväksyntä",
      "confirmDeny": "Vahvista hylkäys",
      "cancel": "Peruuta",
      "backToRequest": "Takaisin"
    }
  },
  "nextActivity": {
    "turn": "Vuoro",
    "thinking": "Pohtii",
    "started": "Aloitettu",
    "completed": "Valmis",
    "failed": "Epäonnistui",
    "succeeded": "Onnistui",
    "waiting": "odottaa...",
    "humanInput": "Ihmisen syöte",
    "humanResponse": "Ihmisen vastaus",
    "orchestrator": "Orkestroija",
    "delegatedTo": "Delegoitu agentille",
    "error": "Virhe",
    "terminalFailure": "Päättävä virhe",
    "thinkingRedactedBody": "Mallin sisäinen päättely on piilotettu.",
    "model": "Malli",
    "tokens": "Tokenit",
    "duration": "Kesto",
    "depth": "Syvyys",
    "in": "sisään",
    "out": "ulos",
    "filterAll": "Kaikki",
    "filterTurns": "Vuorot",
    "filterTools": "Työkalut",
    "filterHitl": "HITL",
    "expand": "Näytä lisää",
    "collapse": "Näytä vähemmän",
    "statusRunning": "Missiota suoritetaan",
    "statusComplete": "Ajo valmis",
    "statusPaused": "Keskeytetty",
    "statusFailed": "Ajo epäonnistui",
    "steps": "Vaiheet",
    "costLive": "Kustannukset tähän mennessä",
    "costEstimate": "Arvioitu hinta",
    "costUnknown": "Tuntematon",
    "usageNotReported_one": "{{count}} kutsu, käyttöä ei raportoitu",
    "usageNotReported_other": "{{count}} kutsua, käyttöä ei raportoitu",
    "costExcludesUnreported_one": "Ei sisällä {{count}} kutsua, jonka käyttöä ei raportoitu",
    "costExcludesUnreported_other": "Ei sisällä {{count}} kutsua, joiden käyttöä ei raportoitu",
    "checkingModelUse": "Tarkistetaan mallin käyttöä…",
    "tokenSpend": "Tokenien kulutus",
    "awaitingFirstCall": "Odotetaan ensimmäistä mallikutsua",
    "executionLog": "Suorituslokki",
    "jumpToLatest": "Siirry uusimpaan",
    "showBreakdown": "Näytä mallikohtainen erittely",
    "hideBreakdown": "Piilota mallikohtainen erittely",
    "unnamedStep": "Nimetön vaihe",
    "runEnding": {
      "tool_result_too_large": "Työkalu palautti liikaa tietoa",
      "host_disconnected": "Palvelimen yhteys katkesi",
      "idle_timeout": "Ajo lakkasi vastaamasta",
      "context_window_exhausted": "Keskustelu kasvoi mallille liian pitkäksi",
      "llm_deadline": "Malli ei vastannut ajoissa",
      "mission_budget_exceeded": "Ajo käytti budjettinsa loppuun",
      "provider_unavailable": "Mallin tarjoaja oli ruuhkautunut tai poissa käytöstä",
      "provider_quota_exhausted": "Mallin tarjoajan kiintiö on käytetty",
      "model_tool_format_rejected": "Malli ei osannut käyttää tehtävän työkaluja",
      "repeated_gate_rejection": "Ajo kaatui toistuvasti samaan valmistumistarkistukseen",
      "criteria_not_met": "Vastaus ei täyttänyt kaikkia onnistumiskriteerejä",
      "no_successful_resource_evidence": "Yhdistetyistä järjestelmistä ei saatu tietoja",
      "timeout": "Kutsu kesti liian kauan",
      "permission_denied": "Pääsy evättiin",
      "not_found": "Jotain ei löytynyt",
      "rate_limited": "Liikaa pyyntöjä",
      "network_error": "Järjestelmään ei saatu yhteyttä",
      "service_unavailable": "Järjestelmä ei ollut käytettävissä",
      "validation_error": "Pyyntö hylättiin virheellisenä",
      "token_limit": "Mallin pituusraja täyttyi",
      "internal_error": "Odottamaton virhe",
      "schema_error": "Vastaus oli odottamattoman muotoinen",
      "model_output_unfit": "Malli antoi toistuvasti vastauksia, joita ei voitu näyttää",
      "transport_error": "Ajon viestejä ei voitu välittää",
      "tool_blocked": "Agion esti kutsun"
    },
    "statusStarting": "Käynnistyy",
    "statusDone": "Valmis",
    "waitingForAnswer": "Odottaa vastaustasi",
    "noModelUse": "Tässä ajossa ei kirjattu mallin käyttöä",
    "questionStep": "Kysymys",
    "messageToYou": "Viesti sinulle",
    "answerStep": "Vastaus",
    "agentStep": "Agentti",
    "runStep": "Ajo",
    "stepId": "Vaiheen tunniste",
    "filterQuestions": "Kysymykset"
  },
  "header": {
    "search": "Hae viestejä",
    "closeSearch": "Sulje haku",
    "metaStarted": "Aloitettu {{time}}",
    "metaTrust": "Luottamus: {{tier}}",
    "metaRuns": "{{count}} ajoa",
    "allRuns": "Kaikki ajot",
    "moreActions": "Lisää toimintoja"
  },
  "nextRunStep": {
    "running": "Käynnissä",
    "waiting": "Ei käynnissä",
    "completed": "Valmis",
    "warning": "Valmis, varoitus",
    "failed": "Epäonnistui",
    "moreTools_one": "+{{count}} muu",
    "moreTools_other": "+{{count}} muuta",
    "unnamedStep": "Nimetön vaihe"
  },
  "runEnd": {
    "endedWithCause": "Ajo päättyi: {{cause}}.",
    "missing": "Puuttuu: {{items}}.",
    "failed": "Ajo epäonnistui.",
    "cause": {
      "agent": "agentti ei saanut työtä valmiiksi",
      "person": "ajo odotti henkilöä",
      "environment": "yhdistetty järjestelmä tai palvelu ei toiminut tarpeen mukaan",
      "platform": "alustalla oli ongelma",
      "missionDesign": "tehtävän asetukset tai rajat pysäyttivät sen",
      "unknown": "syytä ei kirjattu",
      "noAnswer": "kukaan ei vastannut ajoissa"
    },
    "next": {
      "agent": "Tarkenna tehtävää ja aja se uudelleen.",
      "person": "Aja tehtävä uudelleen, kun joku voi vastata.",
      "environment": "Tarkista yhdistetty järjestelmä tai palvelu ja aja tehtävä uudelleen.",
      "missionDesign": "Tarkista tehtävän asetukset ja rajat ja aja se uudelleen.",
      "platform": "Aja tehtävä uudelleen. Jos sama toistuu, ota yhteyttä ylläpitäjään.",
      "unknown": "Aja tehtävä uudelleen. Jos sama toistuu, ota yhteyttä ylläpitäjään.",
      "noAnswer": "Aja tehtävä uudelleen, kun joku voi vastata."
    },
    "missingItem": {
      "criteria": "kaikkien onnistumiskriteerien täyttyminen",
      "resourceData": "tiedot yhdistetyistä järjestelmistä",
      "personAnswer": "henkilön vastaus",
      "stepOutputs": "jokaisen vaiheen tulokset",
      "time": "aika työn loppuun viemiseen",
      "room": "riittävä tila mallin luettavalle tekstille"
    },
    "cutNote": {
      "title": "Osa tämän ajon arvoista lyhennettiin rajoihin sopiviksi.",
      "kind": {
        "delegationHandoff": "Agentilta toiselle välitettyjä tuloksia lyhennettiin tai jätettiin pois.",
        "taskPromptValue": "Osa aiemmista tuloksista lyhennettiin, jotta ne mahtuivat mallille.",
        "contextShortened": "Keskustelun aiempia viestejä lyhennettiin, jotta ne mahtuivat mallille.",
        "runStateText": "Aiempien tavoitteiden tuloksia ja kerättyjä vastauksia lyhennettiin.",
        "verdictEvidence": "Vastauksen tarkistuksessa lainattua näyttöä lyhennettiin.",
        "hydratedRows": "Vaihe sai suuresta taulukosta vain ensimmäiset rivit.",
        "schemaTables": "Osa yhdistetyn järjestelmän tauluista tai tietojoukoista jätettiin pois siitä, mitä mallille näytettiin.",
        "runLimitBounded": "Tehtävään asetettu raja ylitti enimmäisarvonsa, joten ajo käytti enimmäisarvoa."
      },
      "storage": "Kun työtilan tallennus otetaan käyttöön isännällä, arvot säilyvät kokonaisina."
    },
    "code": {
      "CONTEXT_LIMIT": {
        "title": "Mallille lähetetty teksti oli liian pitkä vielä lyhentämisen jälkeenkin",
        "next": "Lyhennä syötettä tai jaa tehtävä pienempiin osiin ja aja se uudelleen."
      },
      "RUN_TIME_LIMIT": {
        "title": "Aikaraja tuli täyteen",
        "next": "Organisaation ylläpitäjä voi nostaa ajon aikarajaa Asetuksissa Agionin sallimissa rajoissa, tai tehtävää voi rajata niin, että se valmistuu nopeammin."
      },
      "SOURCE_READ_INCOMPLETE": {
        "title": "Yhdistetty järjestelmä lakkasi lähettämästä tietoja ennen kuin luku valmistui",
        "next": "Tarkista yhdistetty järjestelmä ja aja tehtävä uudelleen."
      },
      "PROVIDER_QUOTA_EXHAUSTED": {
        "next": "Organisaation ylläpitäjä voi nostaa kiintiötä mallin tarjoajan kanssa tai valita toisen mallin."
      }
    },
    "codeLabel": "Koodi: {{code}}",
    "reason": {
      "hostStoreFull": {
        "title": "Isännän tulosten tallennustila oli täynnä vielä käynnissä olevien ajojen tiedoista",
        "next": "Organisaation omistaja tai ylläpitäjä voi tarkistaa tallennettujen tulosten kokorajan isännän sivulla, minkä jälkeen tehtävän voi ajaa uudelleen."
      }
    }
  }
}
